import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

export const videosApi = createApi({
  reducerPath: "videosApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/v2`,
  }),
  tagTypes: ["Videos", "VideoGeneration", "VideoPreviews"],
  endpoints: (builder) => ({
    // Get Project Videos
    getProjectVideos: builder.query({
      query: (token) => `/${token}/videos/index`,
      providesTags: ["Videos"],
    }),

    // Generate Video
    generateVideo: builder.mutation({
      query: ({ token, jobData }) => ({
        url: `/${token}/videos/generate`,
        method: "POST",
        body: jobData,
      }),
      invalidatesTags: ["VideoGeneration"],
    }),

    // Get Video Generation Status
    getVideoGenerationStatus: builder.query({
      query: ({ token, jobId }) => `/${token}/videos/status/${jobId}`,
      providesTags: (result, error, { jobId }) => [
        { type: "VideoGeneration", id: jobId },
      ],
    }),

    // Download Generated Video
    downloadGeneratedVideo: builder.query({
      query: ({ token, jobId }) => `/${token}/videos/download/${jobId}`,
      responseHandler: (response) => response.blob(),
    }),

    // Save Video Preview
    saveVideoPreview: builder.mutation({
      query: ({ token, jobId, sceneName }) => ({
        url: `/${token}/videos/save/${jobId}/${sceneName}`,
        method: "POST",
      }),
      invalidatesTags: ["VideoPreviews"],
    }),

    // List Video Previews
    getVideoPreviews: builder.query({
      query: (token) => `/${token}/videos/previews`,
      providesTags: ["VideoPreviews"],
    }),

    // List Video Generation Jobs
    getVideoGenerationJobs: builder.query({
      query: ({ token, page = 1, limit = 10, status }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });
        if (status) {
          params.append("status", status);
        }
        return `/${token}/videos/jobs?${params.toString()}`;
      },
      providesTags: ["VideoGeneration"],
    }),

    // Cancel Video Generation
    cancelVideoGeneration: builder.mutation({
      query: ({ token, jobId }) => ({
        url: `/${token}/videos/cancel/${jobId}`,
        method: "POST",
      }),
      invalidatesTags: ["VideoGeneration"],
    }),
  }),
});

export const {
  useGetProjectVideosQuery,
  useGenerateVideoMutation,
  useGetVideoGenerationStatusQuery,
  useDownloadGeneratedVideoQuery,
  useSaveVideoPreviewMutation,
  useGetVideoPreviewsQuery,
  useGetVideoGenerationJobsQuery,
  useCancelVideoGenerationMutation,
} = videosApi;

export default videosApi;
